const tableHeaders = [
  {
    label: 'dealer-code',
    key: 'entity',
    defaultSort: true,
  },
  {
    label: 'vin',
    key: 'vin',
    defaultSort: true,
  },
  {
    label: 'first-name',
    key: 'firstName',
    defaultSort: true,
  },
  {
    label: 'last-name',
    key: 'lastName',
    defaultSort: true,
  },
  {
    label: 'email',
    key: 'email',
    defaultSort: true,
  },
  {
    label: 'Survey Type',
    key: 'surveyType',
    defaultSort: true,
  },
  {
    label: 'Survey Completion Date',
    key: 'surveyCompletionDate',
    defaultSort: true,
  },
  {
    label: 'sid',
    key: 'sid',
    defaultSort: true,
  },
  {
    label: 'interference-method',
    key: 'interferenceMethod',
    defaultSort: true,
  },
  {
    label: 'Survey Outcome',
    key: 'surveyOutcome',
    defaultSort: true,
  },
];

export default () => tableHeaders;
